import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecommendingOfficersSelection } from 'src/app/shared/models/app-models/RecommendingOfficerReselection.model';
import { userDecision } from './officer-reselection-dto.model';
import { ExtendedKeycloakUser, StoreDropdowns } from 'src/app/shared/models/app-models';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-dro-dialog',
  templateUrl: './dro-dialog.component.html',
  styleUrls: ['./dro-dialog.component.scss']
})
export class DroDialogComponent {
  formGroup!: FormGroup;
  destroy$: Subject<boolean> = new Subject()
  KCUserList!: ExtendedKeycloakUser[]
  constructor(public matDialogRef: MatDialogRef<RecommendingOfficersSelection[]>, private store: Store<{
    dp: StoreDropdowns
  }>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder) {
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.KCUserList = dp.UserList as ExtendedKeycloakUser[];
      });
  }
  getNameOfUser(username: string) {
    return this.KCUserList.find((user) => user.username == username)?.value ?? username;
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  ngOnInit() {
    this.formGroup = this.fb.group({});
    this.data.officerSelection.forEach((item: RecommendingOfficersSelection) => {
      const originalDroControl = new FormControl(null, [Validators.required]);
      this.formGroup.addControl(item.originalDRO, originalDroControl);
    });
  }
  onSubmit() {
    if (this.formGroup.valid) {
      // Form is valid, proceed with submission or other actions
      let userDecision: userDecision[] = []
      Object.entries(this.formGroup.value).forEach(([key, value]) => {
        userDecision.push({
          originalDRO: key,
          alternateDRO: value as string
        })
      });
      this.matDialogRef.close({ user_decision: userDecision })
    } else {
      // Form is invalid, mark all fields as touched to trigger validation messages
      this.formGroup.markAllAsTouched();
      return;
    }
  }
}
